<template>
  <div class="low-sales-notice">
    <div v-if="shopName" class="low-sales-notice__shop">
      <span>授权店铺</span><strong>{{ shopName }}</strong>
    </div>

    <section class="low-sales-notice__cleanup">
      <i class="el-icon-delete" aria-hidden="true"></i>
      <div>
        <h3>开启后，仅在观星树考核未达标时自动清理</h3>
        <p>低动销、高动销店铺均清理 <strong>累计销量为0</strong> 的商品；达标后不进行清理。</p>
        <span class="low-sales-notice__muted">仅针对通过观星树上架、近30天内创建且排除最近7天的商品；缺少有效考核或店铺状态未知时暂停清理</span>
      </div>
    </section>

    <section class="low-sales-notice__restriction">
      <i class="el-icon-lock" aria-hidden="true"></i>
      <div>
        <h3>商品应用授权有效期间，不可关闭</h3>
        <p>开启后，在店铺商品应用授权有效且未到期期间，不可关闭“授权下架低效品”；应用授权失效或到期后方可关闭。</p>
      </div>
    </section>

    <daily-publish-quota-notice class="low-sales-notice__quota" />

    <p class="low-sales-notice__consent">点击“{{ confirmLabel }}”，即表示您已了解观星树考核标准，并同意上述自动清理及授权关闭限制。</p>
  </div>
</template>

<script>
import DailyPublishQuotaNotice from './DailyPublishQuotaNotice.vue'

export default {
  name: 'LowSalesAuthorizationNotice',
  components: { DailyPublishQuotaNotice },
  props: {
    shopName: { type: String, default: '' },
    confirmLabel: { type: String, default: '同意并开启授权' }
  }
}
</script>

<style scoped>
.low-sales-notice { color: #303744; font-size: 14px; line-height: 1.6; text-align: left; }
.low-sales-notice h3, .low-sales-notice p { margin: 0; }
.low-sales-notice h3 { font-size: 14px; font-weight: 600; }
.low-sales-notice__shop { display: flex; gap: 12px; align-items: baseline; margin-bottom: 16px; }
.low-sales-notice__shop > span { color: #7b8492; flex-shrink: 0; }
.low-sales-notice__shop strong { overflow-wrap: anywhere; }
.low-sales-notice__cleanup { display: flex; gap: 12px; padding: 16px; border: 1px solid #f2debc; border-radius: 8px; background: #fffbf3; }
.low-sales-notice__cleanup > i { color: #b77920; font-size: 20px; margin-top: 2px; }
.low-sales-notice__cleanup h3 { color: #80591e; margin-bottom: 4px; }
.low-sales-notice__cleanup p strong { color: #b66b12; }
.low-sales-notice__muted { color: #8a8070; font-size: 12px; }
.low-sales-notice__quota { margin: 20px 0; }
.low-sales-notice__restriction { margin-top: 14px; display: flex; gap: 10px; padding: 13px 14px; border: 1px solid #f1d6d3; background: #fff7f6; border-radius: 8px; }
.low-sales-notice__restriction > i { font-size: 18px; margin-top: 2px; color: #bd5950; }
.low-sales-notice__restriction h3 { color: #a64f47; margin-bottom: 4px; }
.low-sales-notice__restriction p { font-size: 12px; color: #896560; }
.low-sales-notice .low-sales-notice__consent { margin-top: 14px; font-size: 12px; color: #7b8492; }
@media (max-width: 520px) {
  .low-sales-notice__cleanup { padding: 12px; }
}
</style>

<style>
.low-sales-authorization-dialog.el-dialog { width: 740px; max-width: calc(100vw - 32px); max-height: 88vh; display: flex; flex-direction: column; border-radius: 12px; overflow: hidden; }
.low-sales-authorization-dialog .el-dialog__header { flex-shrink: 0; padding: 22px 24px 16px; border-bottom: 1px solid #edf0f4; }
.low-sales-authorization-dialog .el-dialog__title { color: #303744; font-size: 18px; font-weight: 600; }
.low-sales-authorization-dialog .el-dialog__headerbtn { top: 25px; right: 24px; }
.low-sales-authorization-dialog .el-dialog__body { min-height: 0; padding: 18px 24px; max-height: calc(100vh - 200px); overflow-y: auto; }
.low-sales-authorization-dialog .el-dialog__footer { flex-shrink: 0; padding: 14px 24px 18px; border-top: 1px solid #edf0f4; }
.low-sales-authorization-confirm.el-message-box { width: 680px; max-width: calc(100vw - 32px); padding: 0; border-radius: 12px; }
.low-sales-authorization-confirm .el-message-box__header { padding: 22px 24px 16px; border-bottom: 1px solid #edf0f4; }
.low-sales-authorization-confirm .el-message-box__title { font-family: inherit; font-size: 18px; font-weight: 600; }
.low-sales-authorization-confirm .el-message-box__headerbtn { top: 25px; right: 24px; }
.low-sales-authorization-confirm .el-message-box__content { padding: 18px 24px; }
.low-sales-authorization-confirm .el-message-box__message { max-height: calc(100vh - 210px); overflow-y: auto; }
.low-sales-authorization-confirm .el-message-box__message > p { margin: 0; line-height: inherit; }
.low-sales-authorization-confirm .el-message-box__btns { padding: 14px 24px 18px; border-top: 1px solid #edf0f4; }
@media (max-width: 520px) {
  .low-sales-authorization-dialog .el-dialog__header, .low-sales-authorization-confirm .el-message-box__header { padding: 18px 16px 14px; }
  .low-sales-authorization-dialog .el-dialog__body, .low-sales-authorization-confirm .el-message-box__content { padding: 16px; }
  .low-sales-authorization-dialog .el-dialog__footer, .low-sales-authorization-confirm .el-message-box__btns { padding: 12px 16px 16px; }
}
</style>
